module.exports = __webpack_public_path__ + "img/ic-info.bbb66b54.png";